import React from 'react'
import PropTypes from 'prop-types'

import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@material-ui/core'
import { Button } from '@/components'
import { ComboboxCarriers } from '@/components/Combobox'
// import { Dialog } from '@/components'

export function SelectCarrierDialog({ open, onClose, onSave }) {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>Escolher Transportadora</DialogTitle>

      <DialogContent dividers>
        <Box py={2}>
          <ComboboxCarriers
            label="Transportadora"
            name="cod_empresa"
            disableClearable
          />
        </Box>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} variant="outlined">
          Fechar
        </Button>

        <Button onClick={onSave} variant="contained" color="primary">
          Salvar
        </Button>
      </DialogActions>
    </Dialog>
  )
}

SelectCarrierDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onSave: PropTypes.func,
}
